const responsiveFontSize = (size, percentage) => {
	const fontSize = parseFloat(size.slice(0, -2)) ? parseFloat(size.slice(0, -2)) : 0
	
	const unit = size.slice(-2) !== '0' ? size.slice(-2) : ''

	return (fontSize - ((percentage / 100) * fontSize)) + unit
}

export default responsiveFontSize